import { render, staticRenderFns } from "./AthleteComparativeDataSummary.vue?vue&type=template&id=7617b0fd&scoped=true&"
import script from "./AthleteComparativeDataSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataSummary.vue?vue&type=style&index=0&id=7617b0fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7617b0fd",
  null
  
)

export default component.exports